import { commonDate } from './utils'
import TimeRangePicker from './TimeRangePicker.vue'

TimeRangePicker.commonDate = commonDate

//按需引入
export {
  TimeRangePicker, 
  commonDate
}

TimeRangePicker.install = (App: any) => {
  App.component('TimeRangePicker', TimeRangePicker)
}

export default TimeRangePicker
